// src/ferramentas/useDebounce.js
import { useState, useEffect } from 'react';

/**
 * Hook customizado que "atrasa" a atualização de um valor.
 * Útil para evitar requisições excessivas em campos de busca.
 * @param {any} value - O valor que você quer "atrasar" (ex: o texto de um input).
 * @param {number} delay - O tempo em milissegundos a esperar antes de atualizar.
 * @returns {any} - O valor "atrasado".
 */
function useDebounce(value, delay) {
  // Estado para guardar o valor "atrasado"
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(
    () => {
      // Configura um timer para atualizar o valor debounced depois do delay
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      // Função de limpeza: cancela o timer se o `value` mudar antes do delay
      // Isso acontece a cada tecla digitada, reiniciando o timer.
      return () => {
        clearTimeout(handler);
      };
    },
    [value, delay] // Só re-executa o efeito se o valor ou o delay mudarem
  );

  return debouncedValue;
}

export default useDebounce;